export { default } from './condensed-footer-content';
